import React from 'react';

export default function ProductCoreDataContent({ data, templateType }) {
  if (!data) {
    return null;
  }

  const baseFields = [
    { key: 'giValue', label: 'GI 值' },
    { key: 'glValue', label: 'GL 值' }
  ];
  const isStandardTemplate = templateType === 'standard-food-label';
  const isBlueWhiteTemplate = templateType === 'blue-white-template';
  const titleConfig = data.titleConfig || {};
  const shouldShowCustomTitle = titleConfig.enabled && (titleConfig.chinese || titleConfig.english);
  const defaultBgColor = isBlueWhiteTemplate ? '#1e90ff' : (isStandardTemplate ? '#5C4A37' : '#1e90ff');

  const baseFieldMap = baseFields.reduce((acc, field) => {
    acc[field.key] = field;
    return acc;
  }, {});
  const normalizedCustomFields = (data.customFields || []).map((field, index) => ({
    ...field,
    _id: field._id || `product-core-data-${index}`
  }));
  const customFieldMap = normalizedCustomFields.reduce((acc, field) => {
    acc[field._id] = field;
    return acc;
  }, {});
  const defaultOrder = [
    ...baseFields.map((field) => field.key),
    ...normalizedCustomFields.map((field) => field._id)
  ];
  const orderedFields = (Array.isArray(data.fieldOrder) && data.fieldOrder.length > 0 ? data.fieldOrder : defaultOrder)
    .map((id) => {
      const baseField = baseFieldMap[id];
      if (baseField) {
        return { ...baseField, value: data[baseField.key] || '' };
      }
      const customField = customFieldMap[id];
      if (customField) {
        return { key: id, label: customField.label, value: customField.value || '' };
      }
      return null;
    })
    .filter(Boolean)
    .filter((field) => field.value);

  const renderTitle = () => {
    if (!shouldShowCustomTitle) {
      if (isStandardTemplate || isBlueWhiteTemplate) {
        return <h3 className="content-section-heading">产品核心数据</h3>;
      }
      return null;
    }

    if (isBlueWhiteTemplate) {
      return (
        <h3
          className="content-section-heading blue-white-title"
          style={{
            backgroundColor: titleConfig.bgColor || defaultBgColor,
            color: titleConfig.textColor || '#ffffff'
          }}
        >
          {titleConfig.english && (
            <div className="blue-white-title-en">{titleConfig.english}</div>
          )}
          <div className="blue-white-title-cn">{titleConfig.chinese || '产品核心数据'}</div>
        </h3>
      );
    }

    return (
      <h3
        className="content-section-heading"
        style={{
          backgroundColor: titleConfig.bgColor || defaultBgColor,
          color: titleConfig.textColor || '#ffffff',
          padding: '8px 12px',
          borderRadius: '6px',
          marginBottom: '12px'
        }}
      >
        {titleConfig.english && (
          <div style={{ fontSize: 12, opacity: 0.9, lineHeight: 1.2 }}>
            {titleConfig.english}
          </div>
        )}
        <div style={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}>
          {titleConfig.chinese || '产品核心数据'}
        </div>
      </h3>
    );
  };

  if (isStandardTemplate || isBlueWhiteTemplate) {
    const table = (
      <div className="label-content-product-basic label-content-product-core-data">
        <table className="info-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
          <tbody>
            {orderedFields.map((field) => (
              <tr key={field.key} className="info-table-row">
                <td className="info-table-label">{field.label}</td>
                <td className="info-table-value">{field.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );

    if (isBlueWhiteTemplate) {
      return (
        <>
          {renderTitle()}
          {table}
        </>
      );
    }

    return (
      <div className="label-content-product-basic label-content-product-core-data">
        {renderTitle()}
        {table.props.children}
      </div>
    );
  }

  return (
    <div className="label-content-product-basic label-content-product-core-data">
      <h3 className="content-section-heading">产品核心数据</h3>
      <div className="info-grid">
        {orderedFields.map((field) => (
          <div key={field.key} className="info-item">
            <span className="info-label">{field.label}：</span>
            <span className="info-value">{field.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
